(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcadda-compare"] && !Shopify.designMode) return;
  try {
    
function initPcaddaCompare(){document.querySelectorAll('[data-pcadda-compare]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const selects=[...root.querySelectorAll('[data-pcc-select]')];const initial=root.querySelector('[data-pcc-result]').cloneNode(true);function update(){selects.forEach(select=>{const result=select.parentElement.querySelector('[data-pcc-result]');const source=[...root.querySelectorAll('template[data-pcc-product]')].find(t=>t.dataset.pccProduct===select.value);result.replaceChildren(...(source?source.content.cloneNode(true):initial.cloneNode(true)).childNodes);[...select.options].forEach(option=>option.disabled=Boolean(option.value&&selects.some(other=>other!==select&&other.value===option.value)));});}selects.forEach(select=>select.addEventListener('change',update));root.querySelector('[data-pcc-clear]').addEventListener('click',()=>{selects.forEach(select=>select.value='');update();});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initPcaddaCompare);else initPcaddaCompare();document.addEventListener('shopify:section:load',initPcaddaCompare);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcadda-home"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',async event=>{const button=event.target.closest('[data-copy-store-address]');if(!button)return;const status=button.parentElement.querySelector('[data-copy-store-status]');const address='PC ADDA, 407, Skylark Building, 60, Nehru Place, New Delhi, Delhi 110019';try{await navigator.clipboard.writeText(address);status.textContent=status.dataset.success;}catch{status.textContent=status.dataset.error;}});
  } catch(e) { console.error(e); }
})();
})();
